<script>
  import { tempStore } from "../../../stores/temp.store";
  import Icon from "../../../components/Icon/Icon.svelte";
  import get from "get-value";
  import { viditelnostTabu } from "../sidebarLeft.func";
  const kodMenu = "legenda";
  let open = false;

  const unsubscribe = tempStore.subscribe((value) => {
    viditelnostMenu(value);
  });

  function viditelnostMenu(value) {
    let menu = get(value, "menu");
    open = kodMenu === menu;
  }
</script>

<!-- Tab change map start -->
<div
  class="sidebar__tab sidebar__tab--description"
  class:js-tab--open={open}
  data-tab="2"
  id="tabVrstvy"
>
  <div
    class="sidebar__close"
    on:click|preventDefault={() => viditelnostTabu(kodMenu)}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.8 35.4">
      <path
        d="M16.5 35c.8.6 1.9.6 2.5-.2.6-.7.6-1.6 0-2.3L6.1 19.6h42.6c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8H6.1l13-12.9c.7-.7.7-1.8 0-2.5s-1.8-.7-2.5 0l-16 16c-.7.7-.7 1.8 0 2.5L16.5 35z"
      />
    </svg>
  </div>
  <div class="sidebar__wrapper">
    <h6 class="sidebar__heading">Legenda</h6>
    <ul class="legenda" id="legenda">
      <li>
        <Icon kod="005" svg-fill="#669d48" />Psy - zaplatené
      </li>
      <li>
        <Icon kod="005" svg-fill="#e39297" />Psy - nezaplatené
      </li>
      <li>
        <Icon kod="005" svg-fill="#acd99a" />Psy - čiastočne zaplatené
      </li>
      <li>
        <Icon kod="026" svg-fill="#6a9a4d" />Komunálny odpad - zaplatené
      </li>
      <li>
        <Icon kod="026" svg-fill="#e39297" />Komunálny odpad - nezaplatené
      </li>
      <li>
        <Icon kod="026" svg-fill="#acd99a" />Komunálny odpad - čiastočne
        zaplatené
      </li>
      <li>
        <Icon kod="047" svg-fill="#b3cca5" />Dane UO - zaplatené
      </li>
      <li>
        <Icon kod="047" svg-fill="#d4ecc9" />Dane UO - čiastočne zaplatené
      </li>
      <li>
        <Icon kod="047" svg-fill="#f4dba5" />Dane UO - nezaplatené
      </li>
      <li>
        <Icon kod="047" svg-fill="#abaaa9" />Dane UO - bez dane
      </li>
      <li>
        <Icon kod="048" svg-fill="#b3cca5" />Dane VKM - zaplatené
      </li>
      <li>
        <Icon kod="048" svg-fill="#d4ecc9" />Dane VKM - čiastočne zaplatené
      </li>
      <li>
        <Icon kod="048" svg-fill="#f4dba5" />Dane VKM - nezaplatené
      </li>
      <li>
        <Icon kod="048" svg-fill="#ecc8c8" />Dane VKM - nevyrubené
      </li>
      <li>
        <Icon kod="048" svg-fill="#abaaa9" />Dane VKM - bez dane
      </li>
      <li>
        <Icon kod="048" svg-fill="#0091C3" />Výmera daní - Viac ako 5x väčšia
      </li>
      <li>
        <Icon kod="048" svg-fill="#2FB1AB" />Výmera daní - Do 5 väčšia
      </li>
      <li>
        <Icon kod="048" svg-fill="#63D492" />Výmera daní - Do 2x väčšia
      </li>
      <li>
        <Icon kod="048" svg-fill="#87F77A" />Výmera daní - Rovnaká
      </li>
      <li>
        <Icon kod="048" svg-fill="#E1AF49" />Výmera daní - Do 2x menšia
      </li>
      <li>
        <Icon kod="048" svg-fill="#FF6500" />Výmera daní - Do 5x menšia
      </li>
      <li>
        <Icon kod="048" svg-fill="#FF0000" />Výmera daní - Viac ako 5x menšia
      </li>
      <li>
        <Icon kod="048" svg-fill="#00A928" />SPF UO - Úplný vlastník
      </li>
      <li>
        <Icon kod="048" svg-fill="#00FF3F" />SPF UO - Polovičný a nadpolovičný
        vlastník
      </li>
      <li>
        <Icon kod="048" svg-fill="#CAFFBC" />SPF UO - Menšinový vlastník
      </li>
      <li>
        <Icon kod="048" svg-fill="#690984" />SPF UO - Správca a polovičný a
        nadpolovičný vlastník
      </li>
      <li>
        <Icon kod="048" svg-fill="#cc6fe8" />SPF UO - Správca a menšinový
        vlastník
      </li>
      <li>
        <Icon kod="048" svg-fill="#f7e5fc" />SPF UO - Správca
      </li>
      <li>
        <Icon kod="048" svg-fill="#0083A2" />SPF VKM - Úplný vlastník
      </li>
      <li>
        <Icon kod="048" svg-fill="#00C9FF" />SPF VKM - Polovičný a nadpolovičný
        vlastník
      </li>
      <li>
        <Icon kod="048" svg-fill="#B3EAFF" />SPF VKM - Menšinový vlastník
      </li>
      <li>
        <Icon kod="048" svg-fill="#ad7d0f" />SPF VKM - Správca a polovičný a
        nadpolovičný vlastník
      </li>
      <li>
        <Icon kod="048" svg-fill="#e5c16e" />SPF VKM - Správca a menšinový
        vlastník
      </li>
      <li>
        <Icon kod="048" svg-fill="#f7e6c0" />SPF VKM - Správca
      </li>
    </ul>
  </div>
</div>
